"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Divider = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Label = _interopRequireDefault(require("../baseComponents/Label"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Divider = function Divider(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("divider-component", props.className),
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "divider-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "line"
  }, " "), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("content", props.text == null && props.count == "" && "hide")
  }, props.text && props.text != null && /*#__PURE__*/_react["default"].createElement("h6", null, props.text), props.count && props.count != "" && /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    colorTheme: "grey",
    shapeStyle: "stroke",
    type: "count",
    text: props.count
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "line"
  }, " ")), props.description && /*#__PURE__*/_react["default"].createElement("div", {
    className: "description"
  }, props.description));
};

exports.Divider = Divider;
Divider.Proptypes = {
  text: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string, _propTypes["default"].object]),
  count: _propTypes["default"].string,
  description: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string, _propTypes["default"].object]),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
Divider.defaultProps = {
  text: null,
  count: "",
  description: null,
  className: "",
  style: {}
};
var _default = Divider;
exports["default"] = _default;